import React from 'react'; 

const containerSecondaryLeft = (props) => (
    <div className={`u-flex justify-content-between f-column f-wrap`}>
        {props.children}
    </div>
);

export default containerSecondaryLeft;


// WEBPACK FOOTER //
// ./src/components/Flight/UI/Mobile/Tuple/ContainerSecondaryLeft/ContainerSecondaryLeft.js